import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Batches from "@/pages/Batches";
import BatchPassport from "@/pages/BatchPassport";
import Suppliers from "@/pages/Suppliers";
import Rulebook from "@/pages/Rulebook";
import Scenarios from "@/pages/Scenarios";
import Lifecycle from "@/pages/Lifecycle";
import AIInsights from "@/pages/AIInsights";
import Denominations from "@/pages/Denominations";
import Admin from "@/pages/Admin";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/batches" element={<Protected><Batches /></Protected>} />
          <Route path="/batches/:id" element={<Protected><BatchPassport /></Protected>} />
          <Route path="/denominations" element={<Protected><Denominations /></Protected>} />
          <Route path="/suppliers" element={<Protected><Suppliers /></Protected>} />
          <Route path="/lifecycle" element={<Protected><Lifecycle /></Protected>} />
          <Route path="/scenarios" element={<Protected><Scenarios /></Protected>} />
          <Route path="/rulebook" element={<Protected><Rulebook /></Protected>} />
          <Route path="/ai" element={<Protected><AIInsights /></Protected>} />
          <Route path="/admin" element={<Protected><Admin /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
